<template>
  <div class="up_box">
    <el-upload
      class="avatar-uploader el-upload--text pdf_up_box"
      :show-file-list="false"
      action
      :before-upload="beforeUpload"
      :on-progress="uploadVideoProcess"
      :on-change="handleChange"
      :data="paramsdata"
      :disabled="isLoading || disable"
      show-text="false"
      ref="uploadPdf"
      :accept="realAccept"
      :http-request="uploadSectionFile"
      drag
      multiple
    >
      <!-- <i
        class="fa avatar-uploader-icon"
        :class="
          `${iconName} ${
            uploadPercent > 0 ? 'accent_color' : 'secondary_color'
          }`
        "
        aria-hidden="true"
      ></i>-->
      <i class="fa fa-file-pdf-o avatar-uploader-icon accent_color" aria-hidden="true"></i>
      <el-progress
        v-if="videoFlag == true"
        type="circle"
        :show-text="false"
        :percentage="uploadPercent"
        class="circle_3 progress_box"
      ></el-progress>
      <el-progress
        v-if="videoFlag == true"
        type="circle"
        :show-text="false"
        :percentage="uploadPercent"
        class="circle_2 progress_box"
      ></el-progress>
      <el-progress
        v-if="videoFlag == true"
        type="circle"
        :show-text="false"
        :percentage="uploadPercent"
        class="circle_1 progress_box"
      ></el-progress>
    </el-upload>
  </div>
</template>

<script>
import { file } from "../../common/api/file.js";
import enumStatus from "@/common/enum";
import { getToken } from "@/common/utils/auth"; // getToken from cookie
import { receivableApi } from "@/common/api/receivableApi";
import { mapGetters } from "vuex";
export default {
  props: {
    filType: String,
    upType: { type: [String, Number], default: 1 },
    disable: Boolean,
    iconName: { type: String, default: "fa-ﬁle-text" },
    accept: { type: String, default: "" },
    postType: { type: String, default: "SingleInvoice" },
    loadApi: { type: String, default: "" }
  },
  data() {
    return {
      videoFlag: true, //是否显示进度条
      uploadPercent: "", //进度条的进度，
      isShowUploadVideo: false, //显示上传按钮
      form: {
        data: "",
        name: "",
        type: ""
      },
      file: "",
      tokenHead: "",
      paramsdata: {
        token: ""
      },
      isLoading: false,
      r100: 100,
      r50: 50,
      fileCheck: false,
      acceptList: {
        pdf: "application/pdf"
      },
      fileList: [],
      fileNum: 0,
      pafList: []
    };
  },
  mounted() {
    this.fileReader = new FileReader();
    this.tokenHead = getToken() || "";
    this.paramsdata.token = this.tokenHead;
  },
  methods: {
    setPer() {
      let { fileNum, fileList } = this;
      if (fileNum > 0 && fileList.length > 0) {
        this.uploadPercent = (fileNum / fileList.length).toFixed(2) * 100;
      }
      if (this.uploadPercent === 100) {
        setTimeout(() => {
          this.$emit("changePercent", this.uploadPercent);
          this.clearFiles();
        }, 500);
      } else {
        this.$emit("changePercent", this.uploadPercent);
      }
    },

    clearFiles() {
      this.$refs["uploadPdf"].clearFiles();
      this.uploadPercent = "";
      this.fileNum = 0;
      this.pafList = [];
    },
    updatePdf(params){
      this.$emit('updatePdf',params)
    },
    uploadSectionFile(params) {
      // update invoice document
      if (this.loadApi && this.loadApi === "uploadInvoice") {
        this.updatePdf(params)
        return;
      }
      var option = {
        file: params.file,
        type: this.postType
      };
      // upload xml or excel
      let upFun = receivableApi.uploadPdf;

      // bulkInvoiceDocumentFiles uploadDocuments
      let isBulkUpload = this.loadApi && this.loadApi === "uploadDocuments";
      if (isBulkUpload) {
        upFun = receivableApi.uploadDocuments;
        option = {
          bulkInvoiceDocumentFiles: params.file
        };
      }
      upFun(option)
        .then(res => {
          if (this.fileNum < this.fileList.length) {
            this.fileNum++;
            this.pafList.push(res);
          }
          this.$store.dispatch("setActionPdfList", this.pafList);
          this.setPer();
          if (isBulkUpload) {
            this.toastSuccess(res.msg)
          }
        })
        .catch(err => {
          this.toast(err);
        });
    },
    beforeUpload(file, fileList) {
        if (this.loadApi&&this.loadApi === "uploadInvoice") {
        return;
      }
      this.isShowUploadVideo = false;
      this.pafList = [];
      this.$store.dispatch("setActionPdfList", this.pafList);
    },
    //进度条
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true;
      this.isLoading = true;
      if (!this.fileCheck) return;
      this.$emit("chageFile", { isLoading: this.isLoading });
      this.uploadPercent = file.percentage.toFixed(0) * 1;
      this.$emit("changePercent", this.uploadPercent);
    },
    submitUpload(e) {
      this.fileReader.readAsDataURL(this.file);
      this.fileReader.onload = () => {
        let base64Str = this.fileReader.result;
        this.imageUrl = base64Str;
        this.form.data = base64Str.split(",")[1];
        this.form.name = this.file.name;
        let tm = this.file.name;
        let strNum = tm.lastIndexOf(".");
        let typeStr = tm.substring(strNum + 1, tm.length);
        this.form.type = typeStr;
      };
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
      // this.fileList
    }
  },
  computed: {
    realAccept() {
      let acceptList = this.acceptList;
      let accept = this.accept;
      return acceptList[accept];
    },
    ...mapGetters({ activePdf: "activePdf" })
  },
  watch: {
    disable() {
      if (!this.disabled) {
        this.isLoading = false;
        this.uploadPercent = 0;
      }
    }
  }
};
</script>
<style scoped>
.up_box {
  position: relative;
  width: 160px;
  height: 160px;
  margin: auto;
}
.avatar-uploader .el-upload {
  /* border: 1px dashed #d9d9d9; */
  border-radius: 6px;
  cursor: pointer;
  position: absolute;
}
.progress_box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  width: 160px;
  height: 160px;
  line-height: 160px;
  text-align: center;
}
/* #0071EB !important */
.avatar {
  width: 160px;
  height: 160px;
  display: block;
}
</style>
